module.exports = __webpack_public_path__ + "static/p2-e17e5ac2b6e448a2a3747411a54ed419.jpg";